import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/opportunities',
    name: 'opportunities',
    redirect: '/opportunities/geral',
    meta: {
      can_show: FEATURES.OPPORTUNITIES,
      search: {
        title: 'Oportunidades',
        description: 'Oportunidades de negócio e alocação para clientes',
        keywords: [
          'oportunidades',
          'negócios',
          'alocação',
          'ofertas',
          'produtos',
        ],
        icon: 'mdi-chart-timeline-variant-shimmer',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@src/modules/opportunities/views/nav-bar/view-nav-bar.vue')
      ),
    children: [
      {
        path: 'geral',
        name: 'opportunities.overview',
        meta: {
          can_show: FEATURES.OPPORTUNITIES,
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/opportunities/views/opportunities/view-opportunities.vue'
            )
          ),
      },
    ],
  },
]
